import { toUserErrorMessage } from '../../lib/apiError';
import { IconAlert } from '../incidents/icons';

interface TableErrorRowProps {
  colSpan: number;
  error: unknown;
  /** Titre affiché en fallback si l'erreur n'est pas typable (ex. "Chargement des incidents"). */
  fallbackTitle: string;
}

/**
 * Ligne d'erreur affichée dans le `<tbody>` d'une table quand la query échoue.
 * Distingue 403 fonctionnel (permission) / 404 / 5xx / réseau / autre, via
 * `toUserErrorMessage`. Évite le silent-fail où `items = []` faisait afficher
 * "Aucun résultat sur cette période" au lieu d'un vrai message d'erreur.
 */
export const TableErrorRow = ({ colSpan, error, fallbackTitle }: TableErrorRowProps) => {
  const { title, description } = toUserErrorMessage(error, fallbackTitle);
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-16">
        <div className="flex flex-col items-center justify-center gap-3 text-center">
          <IconAlert width={28} height={28} className="text-red-400" />
          <div className="max-w-md">
            <p className="text-sm text-zinc-900">{title}</p>
            <p className="text-xs text-zinc-500 mt-1">{description}</p>
          </div>
        </div>
      </td>
    </tr>
  );
};
